export default __webpack_public_path__ + "static/test-a2686586f9836b4ff38ed450eb3d4995.jpg";